import React from 'react'

import { Channel } from 'src/public/js/siteUtilities'

import { t } from 'src/translations'

import { useFlags } from 'shared/components/common/feature_flags/useFlags'
import { useRestaurantRoutes } from 'shared/components/common/restaurant_routes/RestaurantRoutesContext'

import { CartItems } from 'public/components/default_template/online_ordering/cart/Cart'
import {
  getCartQuantity,
  ItemSource
} from 'public/components/default_template/online_ordering/cart/cartUtils'
import CheckoutSection from 'public/components/default_template/online_ordering/checkout/CheckoutSection'
import { useCart } from 'public/components/online_ordering/CartContext'
import OrderPrices from 'public/components/default_template/online_ordering/checkout/payment/OrderPrices'

const OrderSection = () => {
  const { ooAskMapsCashEnabled } = useFlags()
  const { cart, cartReferrer, channel } = useCart()
  const { orderPath, ecommPath } = useRestaurantRoutes()
  const numItems = getCartQuantity(cart)

  return (
    <CheckoutSection
      title={t('order-section.order-details', { numItems })}
      collapsible
    >
      <div className='cartOrder expandableSection'>
        <CartItems editable itemSource={ItemSource.Checkout} />
        <OrderPrices />
        {!ooAskMapsCashEnabled || cartReferrer !== 'ask_maps' ? (
          <a
            href={channel === Channel.ECOMM ? ecommPath : orderPath}
            className='addItemButton'
          >
            {t('cart.add-item')}
          </a>
        ) : null}
      </div>
    </CheckoutSection>
  )
}
export default OrderSection
